import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { get } from "lodash";
import {
  FilterSelect,
  Pagination,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { Search } from "MODULES/shared/components";
import Table from "./Table";
import companiesPagination from "../pagination";

function ApprovedRepairStationSearch({ pushHistory }) {
  const filters = [
    {
      label: "All Repair Stations",
      filters: { repair_station_status: undefined }
    },
    {
      label: "Approved Repair Stations",
      filters: { repair_station_status: "approved" }
    },
    {
      label: "Denied Repair Stations",
      filters: { repair_station_status: "denied" }
    },
    {
      label: "Management Consent Needed",
      filters: { manager_consent_repair_station_status: true }
    }
  ];

  const filterTags = [
    {
      label: "Repair Station Status",
      key: "repair_station_status"
    },
    {
      label: "Management Consent Needed",
      key: "manager_consent_repair_station_status"
    }
  ];

  return (
    <Search search={companiesPagination} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing a company name, code, or contact name..."
                submitOnSingleResult={r => pushHistory(`/companies/${r.id}`)}
              />
              <FilterSelect {...searchProps} filters={filters} right />
            </div>
          </div>
          <TitleWithFilters
            {...searchProps}
            title={`${get(
              searchProps.paginator.toJS(),
              "filters.repair_station_status",
              "all"
            ).toUpperCase()} REPAIR STATIONS`}
            filters={filterTags}
          />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

ApprovedRepairStationSearch.propTypes = {
  pushHistory: PropTypes.func.isRequired
};

export default connect(undefined, { pushHistory: push })(
  ApprovedRepairStationSearch
);



// WEBPACK FOOTER //
// ./app/modules/ApprovedRepairStations/Search/Search.jsx